import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/shared/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <InputPrimitive
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          "h-8 w-full min-w-0 rounded-[var(--radius-field)] border border-input bg-[var(--bg-light)] px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-[var(--green)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive",
          // The mask glyph barely scales with font-size in this font, so make the
          // secret dots prominent with weight + letter-spacing (kept off the placeholder).
          type === "password" &&
            "text-lg font-bold tracking-[0.25em] placeholder:text-base placeholder:font-normal placeholder:tracking-normal",
          className
        )}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
